var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('v-row',[_c('v-col',{staticClass:"d-flex flex-row align-center justify-center flex-wrap",attrs:{"cols":"12"}},[(_vm.researches)?_c('v-btn',{staticClass:"ma-2",attrs:{"color":"success","outlined":""},on:{"click":_vm.exportTable}},[_c('v-icon',[_vm._v("mdi-file-excel-outline")]),_c('span',[_vm._v("Exporter cette étude")])],1):_vm._e()],1),_c('v-col',{attrs:{"cols":"12"}},[_c('v-simple-table',[_c('thead',[_c('tr',[_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"rowspan":2}},[_vm._v("Univers")]),_c('th',{staticClass:"by-1 br-1 text-center",attrs:{"rowspan":2}},[_vm._v("Équipe")]),_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"colspan":"4"},domProps:{"textContent":_vm._s(period.name)}}):_vm._e()}),_c('th',{staticClass:"by-1 br-1 bl-1 text-center",attrs:{"colspan":"4"}},[_vm._v("Total")])],2),_c('tr',[_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?[_c('th',{staticClass:"bb-1 br-1 bl-1 text-center"},[_vm._v("Valeur du stock")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Variation du stock")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Ventes manquées")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("part du CA manquées")])]:_vm._e()}),_c('th',{staticClass:"bb-1 br-1 bl-1 text-center"},[_vm._v(" Valeur moyenne du stock ")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Variation moyenne du stock")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("Moyenne de ventes manquées")]),_c('th',{staticClass:"bb-1 br-1 text-center"},[_vm._v("part moyenne du CA manquées")])],2)]),_c('tbody',[_vm._l((Object.keys(_vm.orderedTeams)),function(universId){return [_c('tr',[_c('th',{staticClass:"border",staticStyle:{"height":"3px"},attrs:{"colspan":_vm.compactMode ? 12 : 12 + 5 * _vm.periods.length}})]),_vm._l((_vm.orderedTeams[universId]),function(team,teamIndex){return _c('tr',[(teamIndex == 0)?_c('td',{staticClass:"bb-1 br-1 bl-1 text-center",attrs:{"rowspan":_vm.orderedTeams[universId].length},domProps:{"textContent":_vm._s(_vm.universeTable[universId].name)}}):_vm._e(),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(team.name + '-' + team.publicName)}}),_vm._l((_vm.periods),function(period){return (!_vm.compactMode)?[_c('td',{staticClass:"bb-1 br-1 bl-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.stocksResearch.data[universId][team.id].data[
                        period.id
                      ].value
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.stocksResearch.data[universId][team.id].data[
                        period.id
                      ].variation
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatMoney(
                      _vm.researches.stocksResearch.data[universId][team.id].data[
                        period.id
                      ].salesLossValue
                    )
                  )}}),_c('td',{staticClass:"bb-1 br-1 text-center",domProps:{"textContent":_vm._s(
                    _vm.dataFormater.formatPercentage(
                      _vm.researches.stocksResearch.data[universId][team.id].data[
                        period.id
                      ].salesLossRate * 100
                    )
                  )}})]:_vm._e()}),_c('td',{class:'bb-1 br-1 bl-1 text-center' +
                  (_vm.researches.stocksResearch.max.total.value ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .meanValue
                    ? ' global-min'
                    : '') +
                  (_vm.researches.stocksResearch.max.byUnivers[universId].value ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .meanValue
                    ? ' univers-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.stocksResearch.data[universId][team.id].total
                      .meanValue
                  )
                )}}),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.stocksResearch.max.total.variation ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .meanVariation
                    ? ' global-min'
                    : '') +
                  (_vm.researches.stocksResearch.max.byUnivers[universId]
                    .variation ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .meanVariation
                    ? ' univers-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.stocksResearch.data[universId][team.id].total
                      .meanVariation
                  )
                )}}),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.stocksResearch.max.total.salesLossValue ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .salesLossMeanValue
                    ? ' global-min'
                    : '') +
                  (_vm.researches.stocksResearch.max.byUnivers[universId]
                    .salesLossValue ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .salesLossMeanValue
                    ? ' univers-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatMoney(
                    _vm.researches.stocksResearch.data[universId][team.id].total
                      .salesLossMeanValue
                  )
                )}}),_c('td',{class:'bb-1 br-1 text-center' +
                  (_vm.researches.stocksResearch.max.total.salesLossRate ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .salesLossMeanRate
                    ? ' global-min'
                    : '') +
                  (_vm.researches.stocksResearch.max.byUnivers[universId]
                    .salesLossRate ==
                  _vm.researches.stocksResearch.data[universId][team.id].total
                    .salesLossMeanRate
                    ? ' univers-min'
                    : ''),domProps:{"textContent":_vm._s(
                  _vm.dataFormater.formatPercentage(
                    _vm.researches.stocksResearch.data[universId][team.id].total
                      .salesLossMeanRate * 100
                  )
                )}})],2)})]})],2)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }